module.exports = __webpack_public_path__ + "img/amx-6.7fb19164.webp";